<lib-client-sub-nav [activeTab]="activeTab" class="d-none d-lg-block"></lib-client-sub-nav>
<section class="left-nav-wrapper scroll-container">
  <router-outlet></router-outlet>
</section>
